import styles from "@/styles/Video.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function OverlayError(_ref) {
  var _error$message;

  var error = _ref.error,
      poster = _ref.poster;
  var errorCode = (error === null || error === void 0 ? void 0 : error.code) || "E-500";
  var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : "エラーが発生しました。しばらく経ってからお試しください。";

  if (poster) {
    return /*#__PURE__*/_jsxs("div", {
      className: styles.withPoster,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.poster,
        style: {
          backgroundImage: "url(".concat(poster, ")")
        }
      }), /*#__PURE__*/_jsx("div", {
        className: styles.message,
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.overlayError,
            children: message
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.overlayErrorCode,
            children: ["code: ", errorCode]
          })]
        })
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("h3", {
        className: styles.overlayError,
        children: message
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.overlayErrorCode,
        children: ["code: ", errorCode]
      })]
    });
  }
}